export const ka = {
  title: 'ხელუხლებელი ტყის პეიზაჟები',
  subtitle: '(2000/2013/2016/2020)',
  download_data: 'https://data.globalforestwatch.org/documents/gfw::intact-forest-landscapes/about',
  learn_more: 'http://www.intactforests.org/',
  content: [
    {
      label: 'ფუნქცია',
      value:
        'განსაზღვრავს მსოფლიოს ბოლო დარჩენილი უფრაგმენტირებული ტყის ლანდშაფტებს, საკმარისად დიდი, რომ შეინარჩუნოს მთელი მშობლიური ბიომრავალფეროვნება და არ აჩვენოს ადამიანის ცვლილების ნიშნები 2020 წლისთვის. ეს ფენა ასევე აჩვენებს ხელუხლებელი ტყის ლანდშაფტების მასშტაბის შემცირებას 2000 წლიდან 2020 წლამდე.',
    },
    {
      label: 'რეზოლუცია',
      value: 'დაახლოებით 1:1 000 000',
    },
    {
      label: 'გეოგრაფიული გაშუქება',
      value: 'გლობალური',
    },
    {
      label: 'წყარო',
      value:
        'პოტაპოვი, პ., მ. კ. ჰანსენი, ლ. ლაესტადიუსი, ს. ტურუბანოვა, ა. იაროშენკო, კ. ტიესი, ვ. სმიტი, ი. ჟურავლევა, ა. კომაროვა, ს. მინემეიერი და ე. ესიპოვა. 2017. "უდაბნოების ბოლო საზღვრები: ხელუხლებელი ტყის ლანდშაფტების დაკარგვის თვალყურის დევნება 2000 წლიდან 2013 წლამდე." Science Advances 3: e1600821.',
    },
    {
      label: 'სიხშირე',
      value: '2020 წელი',
    },
    {
      label: 'შინაარსის თარიღი',
      value:
        'მსოფლიოს IFL რუკა შეიქმნა ექსპერტების მიერ Landsat-ის სურათების ვიზუალური ინტერპრეტაციით. რუკა შეიძლება შეიცავდეს უზუსტობებს გამოსახულების სივრცითი გარჩევადობის შეზღუდვისა და ზოგიერთ რეგიონში მიწათსარგებლობის ადგილობრივი პრაქტიკის შესახებ დამხმარე ინფორმაციის ნაკლებობის გამო. გარდა ამისა, მეთოდოლოგია ვარაუდობს, რომ ხანძარი გზების ან სხვა ინფრასტრუქტურის სიახლოვეს შეიძლება იყოს გამოწვეული ადამიანების მიერ და, შესაბამისად, წარმოადგენს ანთროპოგენური აშლილობის ფორმას. ამ ვარაუდმა შეიძლება გამოიწვიოს IFL-ის მასშტაბის არასაკმარისი შეფასება ბორეალურ ბიომში.',
    },
    {
      label: 'გაფრთხილება',
      value: 'CC BY 4.0',
    },
    {
      label: 'ლიცენზია',
      value:
        'ხელუხლებელი ტყის ლანდშაფტების (IFL) მონაცემთა ნაკრები განსაზღვრავს ბუნებრივი ეკოსისტემების განუყოფელ ფართობებს ტყის ფართობის ზონაში, რომელიც არ აჩვენებს ადამიანის მნიშვნელოვანი აქტივობის ნიშნებს და საკმარისად დიდია, რომ შენარჩუნდეს მთელი ადგილობრივი ბიომრავალფეროვნება, ფართო სპექტრის სახეობების სიცოცხლისუნარიანი პოპულაციების ჩათვლით. IFL ტერიტორიების გამოსახულების მიზნით, შემუშავდა და შეიქმნა კრიტერიუმების ნაკრები, რათა იყოს გლობალურად გამოსაყენებელი და ადვილად განმეორებადი, ეს უკანასკნელი დროთა განმავლობაში განმეორებითი შეფასებების და დამოწმების საშუალებას იძლევა. IFL-ის ტერიტორიები განისაზღვრა, როგორც არაფრაგმენტირებული ლანდშაფტები, მინიმუმ 50,000 ჰექტარი ზომით და მინიმალური სიგანე 10 კილომეტრით. შემდეგ ეს რუქები იყო Landsat-ის სატელიტური სურათებიდან 2000 წლისთვის.',
    },
  ],
  overview: {
    label: 'მიმოხილვა',
    value:
      'გრინპისი, მერილენდის უნივერსიტეტი, რესურსების მსოფლიო ინსტიტუტი და გამჭვირვალე სამყარო. ”ხელუხლებელი ტყის პეიზაჟები. 2000/2013/2016/2020” ხელმისაწვდომია Global Forest Watch-ის მეშვეობით 31/01/2025. www.globalforestwatch.org',
  },
  citation: {
    label: 'ციტატა',
    value: 'საღლამ მეშე მენზერელერი',
  },
};
